/**
 * A helper to use in cases when we need to perform array.includes() on typed arrays
 * and still achieve type narrowing of the passed value.
 *
 * @param arr - The array to check.
 * @param value - The value to check for.
 * @returns - Whether the array includes the value.
 *
 * @example
 *
 * const arr = ['a', 'b', 'c'] as const
 * if (typedArrayIncludes(arr, someValue)) {
 *   // someValue is narrowed to 'a' | 'b' | 'c' here
 * }
 */
export const typedArrayIncludes = <T>(
    arr: T[] | readonly T[],
    value: unknown
): value is T => {
    return arr.includes(value as T)
}
